module.exports = __webpack_public_path__ + "img/loans.f168142c.svg";